<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/payment-manager-new/table">付款管理列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <template v-if="showErrorMsg">
      <error-panel v-if="detailErrorMsg" :message="detailErrorMsg" show-back/>
    </template>
    <template v-else>
    <layout-panel>
      <span slot="header">基本信息</span>
      <el-form ref="basicInfoForm"
               :model="form"
               :rules="basicInfoFormRules"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item v-if="!isBatch" label="付款类型："
                          prop="type">
              <el-select v-model="form.type" @change="payTypeChange"
                         class="width-max">
                <el-option v-for="(label, value) in typeListForSelect"
                          :key="value"
                          :label="label"
                          :value="Number(value)">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 仅对公付款/预付费用显示最后付款日（零工提现到银行卡除外） -->
            <el-form-item v-if="showScheduleDate" label="最后付款日：">
              <el-date-picker
                v-model="form.schedule_date"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                :picker-options="scheduleDatePickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="是否加急："
                          prop="is_urgent">
              <el-radio v-model="form.is_urgent" :label="0">否</el-radio>
              <el-radio v-model="form.is_urgent" :label="1">是</el-radio>
            </el-form-item>
            <el-form-item v-if="form.is_urgent === 1" label="期望日期："
                          prop="expected_date">
               <el-date-picker
                v-model="form.expected_date"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期"
                :picker-options="dateTimePickerRangeOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="付款公司："
                          prop="payment_company">
              <el-select v-model="form.payment_company"
                         class="width-max"
                         @change="paymentCompanyErrorMessage = ''">
                <el-option v-for="item in availablePaymentCompanys"
                           :key="item.id"
                           :label="item.name"
                           :value="Number(item.id)">
                </el-option>
              </el-select>
              <div v-if="paymentCompanyErrorMessage" style="color: #F56C6C; font-size: 12px; margin-top: 3px; line-height: 1; padding: 2px 0; white-space: nowrap; width: 100%;">
                {{ paymentCompanyErrorMessage }}
              </div>
            </el-form-item>
            <el-form-item label="付款说明："
                          prop="desc">
              <el-input placeholder="请输入付款说明" v-model="form.desc" @keyup.native="trimSpace"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel v-if="!isBatch">
      <span slot="header">付款信息</span>
      <el-form ref="payInfoform"
               :model="form"
               :rules="payInfoformRules"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item v-if="form.type" label="付款主体："
                          prop="paid_to_type">
              <el-radio @change="payToTypeChange" v-if="[1, 3].includes(form.type)" v-model="form.paid_to_type" :label="1">对私</el-radio>
              <el-radio @change="payToTypeChange" v-if="[2, 3].includes(form.type)" v-model="form.paid_to_type" :label="2">对公</el-radio>
            </el-form-item>
            <template v-if="form.type === 2">
              <el-form-item label="付款渠道类型：" prop="payment_channel_type">
                <el-radio-group v-model="form.payment_channel_type" @change="paymentChannelTypeChange">
                  <el-radio :label="1">单笔付款</el-radio>
                  <el-radio :label="2">零工提现</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="form.payment_channel_type === 2" label="付款账户类型：" prop="payment_account_type">
                <el-radio-group v-model="form.payment_account_type" @change="paymentAccountTypeChange">
                  <el-radio :label="1">银行卡</el-radio>
                  <el-radio :label="2">支付宝</el-radio>
                  <el-radio :label="3">微信</el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
            <template v-if="form.paid_to_type === 2">
              <el-form-item label="新增对公付款信息："
                            prop="is_add_company">
                <el-radio v-model="form.is_add_company" :label="0">否</el-radio>
                <el-radio v-model="form.is_add_company" :label="1">是</el-radio>
              </el-form-item>
              <el-form-item label="收款对象名称："
                            key="company_name"
                            prop="company_name">
                <remote-select
                  v-if="form.is_add_company === 0"
                  class="width-max"
                  clearable
                  allow-create
                  id-key="id"
                  label-key="name"
                  value-key="id"
                  :label="customerLabel"
                  v-model="form.company_bank_account_id"
                  @change="payCompanyChange"
                  placeholder="请输入收款对象名称搜索"
                  :query-request="getCompanyAccounts"
                  :find-request="getCompanyAccountsDetail">
                </remote-select>
                <el-input v-if="form.is_add_company === 1"
                          placeholder="请填写对公收款对象名称"
                          v-model="form.company_name"></el-input>
              </el-form-item>
            </template>
            <el-form-item label="收款对象名称："
                          v-if="form.paid_to_type === 1"
                          key="user_bank_name"
                          prop="company_name">
              <!-- <el-input placeholder="收款对象名称" disabled v-model="form.company_name"></el-input> -->
              <el-select v-model="form.user_bank_account_id" clearable
                        @change="payUserBankChange"
                        class="width-max">
                <el-option v-for="(item, index) in userBankList"
                          :key="index"
                          :label="item.name"
                          :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">id：{{ item.id }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <template v-if="form.paid_to_type === 2">
              <el-form-item label="备注：">
                <el-input placeholder="请输入备注信息" :disabled="form.paid_to_type === 1 || form.is_add_company === 0" v-model="form.company_bank_remark"></el-input>
              </el-form-item>
            </template>
            <el-form-item label="银行账号："
                          prop="bank_account">
              <el-input placeholder="请输入银行账号" :disabled="form.paid_to_type === 1 || form.is_add_company === 0" v-model="form.bank_account" @keyup.native="trimSpace"></el-input>
            </el-form-item>
            <el-form-item label="开户银行支行："
                          prop="bank">
              <el-input placeholder="请输入开户银行支行" :disabled="form.paid_to_type === 1 || form.is_add_company === 0" v-model="form.bank"></el-input>
            </el-form-item>
            <el-form-item label="开户银行总行："
                          prop="bank_headquarters">
              <el-input placeholder="请输入开户银行总行" :disabled="form.paid_to_type === 1 || form.is_add_company === 0" v-model="form.bank_headquarters"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">费用信息</template>
      <template slot="tools">
        <el-button v-if="showDetailAddBtn && form.type === null" type="primary"
                  size="mini"
                  @click="showNoFormTypeError">批量添加
        </el-button>
        <payment-manager-batch-read-excel v-else-if="showDetailAddBtn" style="display: inline-block;"
          :tableHeader="tableHeader"
          @change="batchReadExcel"/>
        <el-button type="primary"
                  size="mini"
                  @click="excelDemo">下载Demo
        </el-button>

        <el-button type="primary"
                  size="mini"
                  @click="downPaymentSubject()">下载付款科目
        </el-button>
      </template>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="50px">
        <el-row :gutter="20" style="margin-left: 0px">
          <el-col :span="1" class="col-center">序号</el-col>
          <el-tooltip class="item" effect="dark" content="没有项目编号则留空" placement="top">
            <el-col :span="2" class="col-center">项目编号</el-col>
          </el-tooltip>
          <el-col :span="3" class="col-center">费用承担部门</el-col>
          <el-col :span="3" class="col-center">一级科目</el-col>
          <el-col :span="3" class="col-center">二级科目</el-col>
          <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">发票类型</el-col>
          <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">税率%</el-col>
          <el-col :span="2" class="col-center">{{ isPrepaymentType ? '金额' : '应付金额' }}</el-col>
          <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">发票张数</el-col>
          <el-col :span="2" class="col-center">摘要</el-col>
          <el-col :span="1" class="col-center">&nbsp;</el-col>
          <el-col :span="1" class="col-center">&nbsp;</el-col>
        </el-row>
        <br/>

        <el-row :gutter="20" v-for="(detailItem, itemIndex) in form.payment_detail"
                :key="itemIndex"
                class="invoice-row"
                style="margin-top:5px">
          <!--序号-->
          <el-col style="text-align: center" :span="1">
            {{itemIndex+1}}
          </el-col>

          <!-- 项目编号 -->
          <el-col key="project_id"
            :span="2">
            <el-tooltip class="item" effect="dark" :content="detailItem.project_id > 0 ? (detailItem.project_name + '/' + detailItem.project_number) :''" placement="top">
            <remote-select
              v-model="detailItem.project_id"
              class="width-max"
              clearable
              id-key="number"
              label-key="name"
              value-key="id"
              @change="val => changeProject(val, itemIndex)"
              placeholder="请输入项目名称/编号搜索"
              :query-request="(_)=>getAllProjectTable(Object.assign({status: projectStatus.ACHIEVEMENT}, _))"
              :find-request="getProjectDetail">
            </remote-select>
            </el-tooltip>
          </el-col>
          <!-- 费用承担部门 -->
          <el-col key="department_id"
            :span="3">
            <remote-select
              :disabled="!detailItem.canSelectDepartment"
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入部门名称"
              v-model="detailItem.department_id"
              :query-request="searchDepartments"
              :find-request="id => getDepartmentDetail(id, itemIndex)">
            </remote-select>
          </el-col>

          <!--一级科目-->
          <el-col :span="3">
            <el-select v-model="detailItem.first_subject" @change="val => firstSubjectChange(val, itemIndex)">
              <el-option v-for="(label, value) in firstSubjects"
                        :key="value"
                        :label="label"
                        :value="Number(value)">
              </el-option>
            </el-select>
          </el-col>
          <!--二级科目-->
          <el-col :span="3">
            <el-select v-model="detailItem.second_subject">
              <el-option v-for="(label, value) in secondSubjects[itemIndex]"
                        :key="value"
                        :label="label"
                        :value="Number(value)">
              </el-option>
            </el-select>
          </el-col>
          <!--发票类型-->
          <el-col v-if="showFeesInfoFileds" :span="2">
            <el-select v-model="detailItem.invoice_type"
                        @change="val => invoiceTypeChange(val, itemIndex)">
              <el-option v-for="(label, value) in invoiceType"
                        :key="value"
                        :label="label"
                        :value="Number(value)">
              </el-option>
            </el-select>
          </el-col>
          <!--税率-->
          <el-col v-if="showFeesInfoFileds" :span="2" style="text-align:center;overflow: auto;">
            <el-input :disabled="detailItem.invoice_type === 1" placeholder="请输入" v-model="detailItem.tax_rate"></el-input>
            <!-- <el-select
              v-model="detailItem.tax_rate"
              :disabled="detailItem.invoice_type === 1"
              filterable
              allow-create
              default-first-option
              placeholder="请选择">
              <el-option v-for="(label, value) in detailItem.invoice_type === 3 ? {0: '0%', ...taxRateType} : taxRateType"
                        :key="value"
                        :label="label"
                        :value="Number(value)">
              </el-option>
            </el-select> -->
          </el-col>
          <!--含税金额-->
          <el-col :span="2" style="text-align:center;overflow: auto;">
            <el-input placeholder="请输入" v-model="detailItem.amount"></el-input>
          </el-col>
          <!--发票张数-->
          <el-col v-if="showFeesInfoFileds" :span="2">
            <el-input placeholder="请输入" v-model="detailItem.invoice_count"></el-input>
          </el-col>
          <!--摘要-->
          <el-col :span="2">
            <el-input placeholder="请输入" v-model="detailItem.desc"></el-input>
          </el-col>
          <!-- 减少 -->
          <el-col :span="1">
            <i v-if="form.payment_detail.length > 1" @click="removeDetailItem(itemIndex)" class="el-icon-delete-solid"></i>
          </el-col>
          <!-- 添加 -->
          <el-col :span="1">
            <i v-if="itemIndex === form.payment_detail.length - 1 && showDetailAddBtn" @click="addDetailItem" class="el-icon-plus"></i>
          </el-col>
        </el-row>
        <br/>
        <el-row class="invoice-row" :gutter="20">
          <el-col :span="spanWithType">
            <p style="padding: 0; margin:0; text-align: right;">应付金额合计：</p>
          </el-col>
          <el-col :span="2">
            ￥{{totalAmount | seperateThousandsToFixed(2)}}
          </el-col>
          <el-col v-if="showFeesInfoFileds" :span="2">
            {{totalInvoiceCount}}
          </el-col>
        </el-row>

        <el-form-item label="附件"
                      prop="attached_file">
          <el-upload
            class="upload-demo"
            action=""
            :auto-upload="false"
            :on-change="(file, fileList) => {onChangeFile(file, fileList, this.form.attached_file)}"
            :before-remove="(file, fileList) => {beforeRemove(file, fileList, this.form.attached_file)}"
            :multiple="!isGigWorkerWithdrawBankCard"
            :limit="uploadLimit"
            :on-exceed="(file, fileList) => {handleExceed(file, fileList, uploadLimit)}"
            :file-list="fileList"
            ref="upload"
            :accept="uploadAccept"
            >
            <el-tooltip class="item" effect="dark" content="点击上传附件" placement="right">
            <el-button size="small"
                        type="primary">点击上传
            </el-button>
            </el-tooltip>
            <div slot="tip"
                  class="el-upload__tip">{{ uploadTip }}
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </layout-panel>

    <PaymentApproverForm
      :form="form"
      :totalAmount="totalAmount"
      :approverBoundaryValues="approverBoundaryValues"/>
    <el-dialog
      title="错误提示"
      :visible.sync="specialErrorShow"
      width="40%">
      <p>{{specialError.message}}</p>
      <p v-for="(item, index) in specialError.item" :key="index">
        <span>项目编号：{{item.project_number}}</span>
        <span style="margin-left: 30px">缺少预算：{{item.difference}}</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="specialErrorShow = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-button type="primary" @click="onSubmit">提交申请</el-button>
    <el-button @click="$router.back()">取消</el-button>
    </template>
  </div>
</template>

<script>
import jsQR from 'jsqr'
import * as PDFJS from 'pdfjs-dist/build/pdf'
import PDFJSWorker from 'pdfjs-dist/build/pdf.worker.entry.js'
import { basicInfoFormRules, payInfoformRules, reviewInfoformRules } from '../payment-manager.rules.js'
import PaymentManagerBatchReadExcel from '@/views/payment-manager-new/components/PaymentManagerBatchReadExcel'
import { regType } from '@utils/regExp'
import { defaultBatchTableHeader, defaultTableHeader } from '../components/payment-manager-table-header'
import ErrorPanel from '@components/ErrorPanel.vue'

import PaymentApproverForm from '../components/PaymentApproverForm'

PDFJS.GlobalWorkerOptions.workerSrc = PDFJSWorker

export default {
  components: {
    PaymentManagerBatchReadExcel,
    PaymentApproverForm,
    ErrorPanel
  },
  data () {
    return {
      id: 0,
      showErrorMsg: true,
      detailErrorMsg: '',
      paymentCompanyErrorMessage: '',
      adminInfo: {},
      fullPaymentCompanyList: {},
      availablePaymentCompanys: [],
      basicInfoFormRules,
      payInfoformRules,
      reviewInfoformRules,
      fileList: [],
      userBankDetail: {},
      userBankList: [],
      form: {
        department_id: null,
        desc: '',
        type: null,
        is_urgent: 0,
        is_add_company: 0,
        payment_company: null,
        paid_to_type: 0,
        payment_channel_type: 1, // 付款渠道类型
        payment_account_type: 1, // 付款账户类型
        user_bank_account_id: null, // 对私付款，用户账户信息 id
        company_bank_account_id: '', // 对公付款，公司账户信息 id，为0时创建新的对公付款账户信息
        company_name: null,
        company_bank_remark: '', // 对公付款备注
        bank_account: null,
        bank: null,
        bank_headquarters: null,
        department_approver: null,
        first_approver: null,
        second_approver: null,
        third_approver: null,
        fourth_approver: null,
        cc: [],
        cc_name: null,
        expected_date: '',
        schedule_date: '',
        apply_amount: null,
        payment_detail: [{
          project_id: null,
          project_number: null,
          department_id: null,
          canSelectDepartment: true,
          first_subject: null,
          second_subject: null,
          invoice_type: null,
          tax_rate: null,
          amount: null,
          invoice_count: null,
          desc: null,
        }],
        attached_file: []
      },
      // department_approver: null,
      // first_approver: null,
      // second_approver: null,
      // third_approver: null,
      // fourth_approver: null,
      approverBoundaryValues: {
        approve_amount_lv1: 0,
        approve_amount_lv2: 2000,
        approve_amount_lv3: 10000,
        approve_amount_lv4: 50000,
      },
      firstSubjects: {},
      secondSubjects: [{}],
      departments: [],
      loading: false,
      tableHeader: null,
      typeListForSelect: null,
      demoHeader: [
        {
          key: 'department_id',
          text: '费用承担部门',
        },
        {
          key: 'project_number',
          text: '项目编号',
        },
        {
          key: 'first_subject',
          text: '一级科目',
        },
        {
          key: 'second_subject',
          text: '二级科目',
        },
        {
          key: 'amount',
          text: '含税金额',
        },
        {
          key: 'desc',
          text: '摘要',
        },
      ],
      dateTimePickerRangeOptions: {
        disabledDate: function (time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        },
      },
      scheduleDatePickerOptions: {
        disabledDate: function (time) {
          return time.getTime() <= Date.now()
        },
      },
      projectNames: {},
      originFirstSubjects: null,
      originSecondSubjects: null,
      associatedRelationships: null,
      specialErrorShow: false,
      specialError: {
        message: '',
        item: []
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
      type: state => state.paymentManagerNew.type,
      status: state => state.paymentManagerNew.status,
      projectStatus: state => state.customerProjectcost.statusEnum,
      invoiceType: state => state.paymentManagerNew.invoiceType,
      taxRateType: state => state.paymentManagerNew.taxRateType,
    }),
    totalAmount () {
      return this.form.payment_detail.reduce((total, item) => {
        return total + Number(item.amount)
      }, 0)
    },
    totalInvoiceCount () {
      return this.form.payment_detail.reduce((total, item) => {
        return total + Number(item.invoice_count)
      }, 0)
    },
    spanWithType () {
      if (this.$route.meta.isBatch) {
        return 12
      } else {
        if (this.isPrepaymentType) {
          return 12
        }
      }
      return 16
    },
    showFeesInfoFileds () {
      if (this.$route.meta.isBatch) {
        return false
      } else {
        return !this.isPrepaymentType
      }
    },
    isPrepaymentType () {
      return this.form.type === 3
    },
    isBatch () {
      return this.$route.meta.isBatch
    },
    showDetailAddBtn () {
      // 费用信息 是否能新增：除了对公付款/零工提现/银行卡都满足时，不显示新增，其他情况都显示
      return !(this.form.type === 2 && this.form.payment_channel_type === 2 && this.form.payment_account_type === 1)
    },
    isGigWorkerWithdrawBankCard () {
      // 判断是否是零工提现+银行卡的情况
      return this.form.type === 2 && this.form.payment_channel_type === 2 && this.form.payment_account_type === 1
    },
    showScheduleDate () {
      return [2, 3].includes(this.form.type) && !this.isGigWorkerWithdrawBankCard
    },
    uploadAccept () {
      // 零工提现+银行卡时，只允许上传excel文件
      if (this.isGigWorkerWithdrawBankCard) {
        return '.xls, .xlsx'
      }
      // 其他情况保持原有逻辑
      return '.jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .xls, .xlsx, .doc, .docx, .ofd, .xml, .zip'
    },
    uploadLimit () {
      // 零工提现+银行卡时，只能上传一个文件
      if (this.isGigWorkerWithdrawBankCard) {
        return 1
      }
      // 其他情况保持原有逻辑
      return 50
    },
    uploadTip () {
      // 零工提现+银行卡时的提示文本
      if (this.isGigWorkerWithdrawBankCard) {
        return '请上传EXCEL文件，仅支持上传1个文件'
      }
      // 其他情况的提示文本
      return '请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/OFD/XML/ZIP文件，仅支持上传50个文件,20以上时建议上传zip格式'
    },
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {
    if (this.isBatch) {
      this.form.type = 4
      this.tableHeader = defaultBatchTableHeader
    } else {
      this.tableHeader = defaultTableHeader
    }
    // 付款类型下拉框,不支持选择批量付款项目,需要单独处理 type 列表
    this.typeListForSelect = filter.copyJson(this.type)
    delete this.typeListForSelect[4]
    delete this.typeListForSelect[5]
  },
  mounted () {},
  methods: {
    ...request.map([
      'getAllProjectTable',
      'getProjectDetail',
      'getPlatformUsersIndex',
      'getPlatformUsersDetail',
      'getCompanyAccountManagementTable',
      'getCompanyAccountManagementDetail',
    ]),
    async onLoad () {
      await this.getMeDetail(this.user.id)
      if (this.showErrorMsg) return

      await this.getDepartments()
      await this.getFinCenterConfigs()
      if (this.showErrorMsg) return

      await this.fetchUserBankDetail('getuserAccountDetailByUserID', {id: this.user.id})
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      } else {
        // sanji 说自己选付款公司
        // this.form.payment_company = 1
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    getMeDetail (id) {
      return this.getPlatformUsersDetail({id}).then(({data}) => {
        if (!Array.isArray(data.company_ids) || data.company_ids.length === 0) {
          this.detailErrorMsg = '您的账号尚未配置所属公司主体，无法使用付款申请/修改功能。请联系管理员为您配置所属公司主体'
          this.showErrorMsg = true
        } else {
          this.adminInfo = data
          this.adminInfo.company_ids = data.company_ids.map(item => item * 1)
          this.showErrorMsg = false
        }
      }).catch((error) => {
        this.detailErrorMsg = '获取用户信息失败: ' + error
        this.showErrorMsg = true
      })
    },
    setupProjectNames (data) {
      let reqProjectApis = []
      data.payment_detail.forEach((item, index) => {
        item.project_id = item.project_id + ''
        reqProjectApis.push(item.project_id)
      })
      reqProjectApis = _.uniq(reqProjectApis)
      reqProjectApis = reqProjectApis.filter(item => item > 0).map(id => request('getProjectDetail', {id: id}))
      return request.all.common(reqProjectApis).then(res => {
        res.map(item => {
          if (item.data.name && item.data.number) {
            this.projectNames[item.data.id] = item.data.name
          }
        })
      })
    },
    setForm (id) {
      request('getPaymentManagerDetail', {id}).then(async ({data}) => {
        await this.setupProjectNames(data)
        filter.setLoop(this.form, data)
        this.form.cc = this.form.cc.map(item => {
          return Number(item)
        })
        this.fileList = data.attached_file
        const firstSubjectIds = this.associatedRelationships[this.form.type]
        const firstSubjects = {}
        for (const id in firstSubjectIds) {
          firstSubjects[id] = this.originFirstSubjects[id]
        }
        this.firstSubjects = firstSubjects

        data.payment_detail.forEach((item, index) => {
          item.project_id = item.project_id + ''
          item.project_name = item.project_id !== 0 ? this.projectNames[item.project_id] : ''
          const secondSubjects = {}
          const secondSubjectIds = firstSubjectIds[item.first_subject]
          for (const index in secondSubjectIds) {
            const id = secondSubjectIds[index]
            secondSubjects[id] = this.originSecondSubjects[id]
          }
          this.secondSubjects[index] = secondSubjects

          // 当一级科目被禁用的时候，需要重置为 null
          if (!this.firstSubjects[item.first_subject]) {
            item.first_subject = null
          }

          // 当二级科目被禁用的时候，需要重置为 null
          if (!secondSubjects[item.second_subject]) {
            item.second_subject = null
          }

          if (item.project_number && Number(item.project_id)) {
            if (item.project_number[0] === 'H') {
              item.canSelectDepartment = true
            } else {
              item.canSelectDepartment = false
            }
          } else {
            item.canSelectDepartment = true
          }
          if (parseInt(item.project_id) === 0) {
            item.project_id = null
          }
          if (parseInt(item.department_id) === 0) {
            item.department_id = null
          }
        })


        // 校验付款公司是否在 fullPaymentCompanyList 中且未被禁用，以及在当前账号配置的所属公司主体中
        if (this.form.payment_company) {
          const company = this.fullPaymentCompanyList[this.form.payment_company]
          if (!company || company.is_disabled) {
            this.paymentCompanyErrorMessage = `当前付款公司【${company ? company.name : ''}】已被禁用，请重新选择`
            this.form.payment_company = null
          } else if (!this.adminInfo.company_ids.includes(this.form.payment_company)) {
            // 如果付款公司不在当前账号配置的所属公司主体中，则清空选择并设置提示信息
            this.paymentCompanyErrorMessage = `当前付款公司【${company ? company.name : ''}】不在您账号的所属公司主体中，请重新选择`
            this.form.payment_company = null
          }
        }
        // 付款信息使用快照内容
        this.setBankInfo(data.bank_account_snapshot)
        this.form.payment_channel_type = Number(this.form.payment_channel_type || 0)
        this.form.payment_account_type = Number(this.form.payment_account_type || 0)
        if (this.form.type === 2) {
          this.form.payment_channel_type = this.form.payment_channel_type || 1
          this.form.payment_account_type = this.form.payment_account_type || 1
        }

        if (data.is_urgent === 0) {
          this.form.expected_date = ''
        }
        this.showErrorMsg = false
      }).catch((e) => {
        this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
        this.showErrorMsg = true
      })
    },
    getForm () {
      const form = filter.copyJson(this.form)
      if (this.form.is_add_company === 1) { // 添加 对公账号
        form.company_bank_account_id = 0
      }
      if (this.form.paid_to_type === 1) {
        form.company_bank_account_id = 0
      } else {
        form.user_bank_account_id = 0
      }

      form.payment_detail.forEach(item => {
        item.department_id = item.department_id || 0
        if (item.invoice_type === 1) { // 普通票
          item.tax_rate = 0
        }
        item.project_number = item.project_number || ''
        item.project_id = item.project_id || 0
        item.department_id = item.department_id || 0
        if ([3, 4].includes(form.type)) { // 批量付款申请 或 预付款
          item.invoice_type = 0
          item.tax_rate = 0
          item.invoice_count = 0
        }
      })
      if (form.type === 4) { // 批量付款申请
        form.paid_to_type = 0
      }
      form.apply_amount = this.totalAmount
      form.user_bank_account_id = form.user_bank_account_id || 0

      if (!this.form.special_approver) {
        this.form.special_approver = 0
      }

      if (form.type !== 2) {
        form.payment_channel_type = 1
        form.payment_account_type = 0
      }

      form.invoice_numbers = form.attached_file.map(item => {
        return item.invoice_number
      })
      // 零工提现到银行卡最后付款日传空
      if (form.type === 2 && form.payment_channel_type === 2 && form.payment_account_type === 1) {
        form.schedule_date = ''
      }
      // 后端要求值为 0 时不传递该字段
      if (Number(form.payment_channel_type) === 0) {
        delete form.payment_channel_type
      }
      if (Number(form.payment_account_type) === 0) {
        delete form.payment_account_type
      }
      return form
    },
    onSubmit () {
      if (!this.adminInfo.company_ids.includes(this.form.payment_company)) {
        this.$message.error('所选付款公司不在您账号配置的所属公司主体中')
        return false
      }

      if (!this.checkPaymentDetail()) {
        return false
      }
      if (this.form.type !== 1 && this.form.attached_file.length === 0) {
        this.$message.error('请添加附件！')
        return
      }
      // 如果付款渠道类型不是零工提现，临时移除付款账户类型的校验规则
      if (this.$refs.payInfoform && this.form.type === 2 && this.form.payment_channel_type !== 2) {
        const payInfoformRules = {...this.payInfoformRules}
        delete payInfoformRules.payment_account_type
        this.$refs.payInfoform.rules = payInfoformRules
      }
      const forms = ['basicInfoForm', 'payInfoform', 'reviewInfoform']
      const validates = forms.filter(item => {
        return this.$refs[item]
      }).map(item => {
        return this.$refs[item].validate()
      })
      Promise.all(validates).then(_ => {
        this.id ? this.update(this.id) : this.create()
      }).catch(_ => {
        this.$message.error('提交内容填写不正确！')
      }).finally(() => {
        // 恢复原始校验规则
        if (this.$refs.payInfoform && this.form.type === 2 && this.form.payment_channel_type !== 2) {
          this.$refs.payInfoform.rules = this.payInfoformRules
        }
      })
    },
    checkPaymentDetail () {
      let list = this.form.payment_detail
      let rule = {
        first_subject: '一级科目',
        second_subject: '二级科目',
        amount: '含税金额',
        desc: '摘要',
      }
      for (let i = 0; i < list.length; i++) {
        for (const ruleKey in rule) {
          if (!list[i][ruleKey]) {
            this.$message.error(`第${i + 1}行,` + rule[ruleKey] + '不能为空！')
            return false
          }
        }
        if (!regType('money').test(Math.abs(list[i].amount))) {
          this.$message.error(`第${i + 1}行,应付金额必须为合法的价格数字,且至多保留两位小数`)
          return false
        }
        if (list[i].tax_rate > 100 || list[i].tax_rate < 0) {
          this.$message.error(`第${i + 1}行,` + '请输入正确的税率,范围0 ~ 100！')
          return false
        }
        let projectNumberFirstChart = ''
        if (list[i].project_number && typeof list[i].project_number === 'string') {
          projectNumberFirstChart = list[i].project_number.substr(0, 1)
        }
        if (projectNumberFirstChart === 'H' || !list[i].project_number) { // 项目编号首字母为H或者无编号
          if (!list[i].department_id) {
            this.$message.error('请选择费用承担部门！')
            return false
          }
        }
        if (!list[i].invoice_count && !this.isBatch && !this.isPrepaymentType) {
          this.$message.error('请填写发票张数')
          return false
        }
      }
      if (this.totalAmount === 0) {
        this.$message.error('应付金额合计不能为0')
        return false
      }
      return true
    },
    excelDemo () {
      let demo = [{
        'department_id': '产品技术部',
        'project_number': '项目A',
        'first_subject': '库存商品-wip',
        'second_subject': '供应商货款',
        'amount': '1000',
        'desc': '供应商A货款',
        'invoice_type': '普票',
        'tax_rate': 0,
        'invoice_count': 1,
      }, {
        'department_id': '',
        'project_number': '',
        'first_subject': '管理费用',
        'second_subject': '餐费',
        'amount': '1500',
        'desc': '餐费',
        'invoice_type': '专票',
        'tax_rate': 6,
        'invoice_count': 1,
      }, {
        'department_id': '请输入部门名称,不指定部门时请留空',
        'project_number': '请输入项目编号,不指定时请留空',
        'first_subject': '请输入一级科目名称,对应付款类型层级关系',
        'second_subject': '请输入二级科目名称,对应一级科目层级关系',
        'amount': '付款申请金额',
        'desc': '请删除本说明行',
        'invoice_type': '普票等不需要交税时税率请填写0',
        'tax_rate': '税率范围 0~100',
        'invoice_count': '发票张数',
      }]
      let demoHeader = filter.copyJson(this.demoHeader)

      if (!this.isBatch) {
        let extraHeader = [
          {
            'key': 'invoice_type',
            'text': '发票类型',
          }, {
            'key': 'tax_rate',
            'text': '税率',
          }, {
            'key': 'invoice_count',
            'text': '发票张数',
          }
        ]
        demoHeader = demoHeader.concat(extraHeader)
      }
      this.$export(this.$route.meta.title + 'demo', demo, {fileHeader: demoHeader})
    },
    downPaymentSubject () {
      const subjectHeader = [
        {
          'key': 'payment_type',
          'text': '付款类型',
        }, {
          'key': 'first_subject',
          'text': '一级科目',
        }, {
          'key': 'second_subject',
          'text': '二级科目',
        }
      ]
      let subjectDemo = []
      const rel = this.associatedRelationships

      for (const typeId in rel) {
        if (rel.hasOwnProperty(typeId)) {
          for (const firstId in rel[typeId]) {
            if (rel[typeId].hasOwnProperty(firstId)) {
              for (const secondIndex in rel[typeId][firstId]) {
                if (rel[typeId][firstId].hasOwnProperty(secondIndex)) {
                  const secondId = rel[typeId][firstId][secondIndex]

                  subjectDemo.push({
                    'payment_type': this.type[typeId],
                    'first_subject': this.originFirstSubjects[firstId],
                    'second_subject': this.originSecondSubjects[secondId],
                  })
                }
              }
            }
          }
        }
      }

      this.$export('付款科目', subjectDemo, {fileHeader: subjectHeader})
    },
    create () {
      request.loading('createPaymentManagerDataNew', {...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$router.go(0)
        }, () => {
          this.$router.push({path: '/payment-manager-new/table/'})
        })
      }).catch(error => {
        if (error.response.data.ret === 190153) {
          this.specialError = JSON.parse(error.response.data.msg)
          this.specialErrorShow = true
        } else {
          this.$alert(error.message, '错误提示', {type: 'thrown'})
        }
      })
    },
    update (id) {
      request.loading('updatePaymentManagerDataNew', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/payment-manager-new/table/'})
        })
      }).catch(error => {
        if (error.response.data.ret === 190153) {
          this.specialError = JSON.parse(error.response.data.msg)
          this.specialErrorShow = true
        } else {
          this.$alert(error.message, '错误提示', {type: 'thrown'})
        }
      })
    },
    resetFormFields () {
      const form = {
        department_id: this.form.department_id,
        type: null,
        is_urgent: 0,
        is_add_company: 0,
        payment_company: null,
        paid_to_type: 0,
        user_bank_account_id: 0, // 对私付款，用户账户信息 id
        company_bank_account_id: '', // 对公付款，公司账户信息 id，为0时创建新的对公付款账户信息
        company_name: null,
        bank_account: null,
        bank: null,
        department_approver: this.form.first_approver,
        first_approver: this.form.first_approver,
        second_approver: this.form.second_approver,
        third_approver: this.form.third_approver,
        fourth_approver: this.form.fourth_approver,
        special_approver: null,
        expected_date: '',
        schedule_date: '',
        apply_amount: null,
        payment_detail: [{
          project_id: null,
          project_number: null,
          department_id: null,
          canSelectDepartment: true,
          first_subject: null,
          second_subject: null,
          invoice_type: null,
          tax_rate: null,
          amount: null,
          invoice_count: null,
          desc: null,
        }],
        attached_file: []
      }
      this.form = JSON.parse(JSON.stringify(form))
      this.$refs.upload.clearFiles()
      this.setDefaultApproverInfo()
    },
    getDepartments () {
      return request.common('getFinCenterDepartmentTableList', {per_page: 100}).then(({data}) => {
        this.departments = data.data
      })
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        // 检查付款公司权限
        const allSource = data.payment_apply_our_company_source.map(item => ({...item, id: item.id * 1}))
        this.fullPaymentCompanyList = allSource.reduce((acc, item) => {
          acc[item.id] = item
          return acc
        }, {})
        this.availablePaymentCompanys = allSource.filter(item => !item.is_disabled && this.adminInfo.company_ids.includes(item.id))

        // 检查是否有可用的付款公司
        if (this.availablePaymentCompanys.length === 0) {
          this.detailErrorMsg = '您的账号配置的所属公司主体已被全部禁用，无法使用付款申请功能。请联系管理员启用对应公司主体，或为您重新分配可用的公司主体'
          this.showErrorMsg = true
        } else {
          this.showErrorMsg = false
        }

        this.setupApproverLevel(data)
        this.setupSubjects(data)
      })
    },
    setupApproverLevel (data) {
      this.approverBoundaryValues.approve_amount_lv1 = data.approve_amount_lv1 || this.approverBoundaryValues.approve_amount_lv1
      this.approverBoundaryValues.approve_amount_lv2 = data.approve_amount_lv2 || this.approverBoundaryValues.approve_amount_lv2
      this.approverBoundaryValues.approve_amount_lv3 = data.approve_amount_lv3 || this.approverBoundaryValues.approve_amount_lv3
      this.approverBoundaryValues.approve_amount_lv4 = data.approve_amount_lv4 || this.approverBoundaryValues.approve_amount_lv4
    },
    setupSubjects (data) {
      this.originFirstSubjects = this.expandData(_.values(data.first_subject_source))
      this.originSecondSubjects = this.expandData(_.values(data.second_subject_source))
      this.associatedRelationships = data.payment_apply_subject_map
      if (this.isBatch) {
        this.payTypeChange(this.form.type)
      }
    },
    expandData (data) {
      data = data.filter(item => { return item.is_disabled < 1 })
      let result = {}
      for (const dataKey in data) {
        const tmp = data[dataKey]
        result[tmp.id] = tmp.name
      }
      return result
    },
    fetchUserBankDetail (uri, params) {
      return request.common(uri, params).then(({data}) => {
        // this.userBankDetail = data
        this.userBankList = data

        this.setDefaultApproverInfo()
      })
    },
    getCompanyAccounts (key) {
      const params = {
        company_name: key.keyword,
        is_disabled: 0,
        per_page: 50
      }
      return request.common('getCompanyBankAccountForSearch', params).then(data => {
        data.data.data.forEach(item => {
          if (item.remark) {
            item.name = `${item.company_name}(${item.remark})`
          } else {
            item.name = item.company_name
          }
        })
        return data
      })
    },
    getCompanyAccountsDetail (id) {
      return request.common('getCompanyBankAccountById', id)
    },
    removeDetailItem (index) {
      this.secondSubjects.splice(index, 1)
      this.form.payment_detail.splice(index, 1)
      this.form.payment_detail = JSON.parse(JSON.stringify(this.form.payment_detail))
    },
    addDetailItem () {
      this.form.payment_detail.push(
        {
          project_id: null,
          project_number: null,
          department_id: null,
          canSelectDepartment: true,
          first_subject: null,
          second_subject: null,
          invoice_type: null,
          tax_rate: null,
          amount: null,
          invoice_count: null,
          desc: null,
        }
      )
      this.secondSubjects.push({})
    },
    showNoFormTypeError () {
      this.$message.error('请先选择付款类型')
    },
    changeProject (val, index) {
      this.form.payment_detail[index].project_id = val.id
      this.form.payment_detail[index].project_name = val.name
      this.form.payment_detail[index].project_number = val.number

      // let firstSubject = null
      let canSelectDepartment = true
      if (val === '') {
        // firstSubject = 1
        canSelectDepartment = true
        // if (!this.form.payment_detail[index].first_subject) {
        //   this.form.payment_detail[index].first_subject = 1
        // }
        this.form.payment_detail[index].canSelectDepartment = true
      } else {
        if (val.number.length > 0) {
          const projectNumberFirstChart = val.number[0]
          if (projectNumberFirstChart === 'H') { // 项目编号首字母为H
            // firstSubject = 2
            canSelectDepartment = true
          } else { // 禁用 费用承担部门
            this.form.payment_detail[index].department_id = null
            // firstSubject = 1
            canSelectDepartment = false
          }
        }
      }
      if (this.form.type && val !== '' && ![3].includes(this.form.type)) { // 不是预付款类型 默认有 一级科目
        // if (!this.form.payment_detail[index].first_subject) {
        //   this.form.payment_detail[index].first_subject = firstSubject
        // }
        // this.firstSubjectChange(firstSubject, index)
      } else { // 清空一级科目
        this.form.payment_detail[index].first_subject = null
      }
      this.form.payment_detail[index].canSelectDepartment = canSelectDepartment
    },
    setDefaultApproverInfo () {
      const defauleValue = this.userBankList[0]

      this.form.department_id = defauleValue.department_id
      //  部门领导审批人 默认 同步一级
      this.form.department_approver = defauleValue.first_approver
      this.form.first_approver = defauleValue.first_approver
      this.form.second_approver = defauleValue.second_approver
      this.form.third_approver = defauleValue.third_approver
      this.form.fourth_approver = defauleValue.fourth_approver
    },
    setBankInfo (bank) {
      if (!bank) return
      this.form.company_bank_remark = bank.remark
      this.form.bank_account = bank.bank_account
      this.form.company_name = bank.user_name || bank.company_name
      this.form.bank_headquarters = bank.bank_headquarters
      this.form.bank = bank.bank
      this.form.payment_channel_type = Number(bank.payment_channel_type || this.form.payment_channel_type || 1)
      this.form.payment_account_type = Number(bank.payment_account_type || this.form.payment_account_type || 1)
    },
    resetUserBankInfo () {
      this.form.user_bank_account_id = null
      this.form.company_name = null
      this.form.bank_account = null
      this.form.bank = null
      this.form.bank_headquarters = null
    },
    resetCompanyBankInfo () {
      if (!this.form.company_bank_account_id) {
        this.form.user_bank_account_id = null
        this.form.company_name = null
        this.form.bank = null
        this.form.bank_account = null
      }
    },
    invoiceTypeChange (val, index) {
      if (val === 1) {
        this.form.payment_detail[index].tax_rate = 0
      } else {
        this.form.payment_detail[index].tax_rate = null
      }
    },
    payTypeChange (val) {
      if (val === 1) {
        this.form.paid_to_type = 1
        this.resetUserBankInfo()
      } else if (val === 2) {
        this.form.paid_to_type = 2
        this.resetCompanyBankInfo()
      } else if (val === 3) {
        this.form.paid_to_type === 1
          ? this.resetUserBankInfo() : this.resetCompanyBankInfo()
      } else {
        this.resetCompanyBankInfo()
      }
      if (![2, 3].includes(val)) {
        this.form.schedule_date = ''
      }
      if (val === 2) {
        this.form.payment_channel_type = 1
        this.form.payment_account_type = 1
      } else {
        this.form.payment_channel_type = 0
        this.form.payment_account_type = 0
      }
      this.resetSubjectsWithPayTypeChange(val)
    },
    payToTypeChange (val) {
      if (val === 1) {
        this.resetUserBankInfo()
        this.form.payment_channel_type = 0
        this.form.payment_account_type = 0
      } else {
        this.resetCompanyBankInfo()
        this.form.payment_channel_type = this.form.payment_channel_type || 1
        this.form.payment_account_type = this.form.payment_account_type || 1
      }
    },
    paymentChannelTypeChange (val) {
      // 当切换到单笔付款时，清除付款账户类型的值
      if (val === 1) {
        this.form.payment_account_type = 1
      }
      // 付款渠道类型变更时，重置费用信息表格数据
      this.resetPaymentDetailOnChannelOrAccountChange()
    },
    paymentAccountTypeChange (val) {
      // 付款账户类型变更时，重置费用信息表格数据
      this.resetPaymentDetailOnChannelOrAccountChange()
    },
    resetPaymentDetailOnChannelOrAccountChange () {
      // 重置费用信息表格的所有字段为初始状态，只保留一条空数据
      const resetDetail = [{
        project_id: null,
        project_number: null,
        department_id: null,
        canSelectDepartment: true,
        first_subject: null,
        second_subject: null,
        invoice_type: null,
        tax_rate: null,
        amount: null,
        invoice_count: null,
        desc: null,
      }]
      this.form.payment_detail = JSON.parse(JSON.stringify(resetDetail))
      // 初始化表格数据时，附件也需要清除（避免切换付款渠道/账户类型后残留旧附件）
      this.form.attached_file = []
      this.fileList = []
      if (this.$refs.upload && typeof this.$refs.upload.clearFiles === 'function') {
        this.$refs.upload.clearFiles()
      }
      // 重置二级科目选项数组，只保留一个空对象
      this.secondSubjects = [{}]
      // 重新设置一级科目选项（根据付款类型）
      if (this.form.type && this.associatedRelationships[this.form.type]) {
        const firstSubjectIds = this.associatedRelationships[this.form.type]
        const firstSubjects = {}
        for (const id in firstSubjectIds) {
          firstSubjects[id] = this.originFirstSubjects[id]
        }
        this.firstSubjects = firstSubjects
      }
    },
    payCompanyChange (val) {
      this.form.company_bank_account_id = val.id
      this.setBankInfo(val)
    },
    payUserBankChange (val) {
      const bank = this.userBankList.find(bank => bank.id === val)
      this.setBankInfo(bank)
      // 设置用户默认费用承担部门
      this.setDefaultPaymentDetailDepartment(bank)
    },
    setDefaultPaymentDetailDepartment (bank) {
      if (!this.id) {
        this.form.payment_detail.forEach(detail => {
          if (detail.canSelectDepartment) {
            detail.department_id = bank.department_id
          }
        })
      }
    },
    resetSubjectsWithPayTypeChange (val) {
      this.form.payment_detail.forEach(element => {
        element.first_subject = null
        element.second_subject = null
        return element
      })
      const firstSubjectIds = this.associatedRelationships[val]
      const firstSubjects = {}
      for (const id in firstSubjectIds) {
        firstSubjects[id] = this.originFirstSubjects[id]
      }
      this.firstSubjects = firstSubjects
    },
    firstSubjectChange (val, index) {
      this.form.payment_detail[index].second_subject = null
      const secondSubjects = {}
      const secondSubjectIds = this.associatedRelationships[this.form.type][val]
      for (const index in secondSubjectIds) {
        const id = secondSubjectIds[index]
        secondSubjects[id] = this.originSecondSubjects[id]
      }
      this.secondSubjects[index] = secondSubjects
    },
    async batchReadExcel (val) {
      await this.handleExcelData(val)
      val.forEach((item) => {
        this.form.payment_detail.push(item)
      })
    },
    async handleExcelData (val) {
      const swapKeyValueInvoiceType = {}
      const swapKeyValueFirstSubjects = {}
      const swapKeyValueSecondSubjects = {}
      const swapKeyValueDepartments = {}
      for (const key in this.invoiceType) {
        if (Object.hasOwnProperty.call(this.invoiceType, key)) {
          swapKeyValueInvoiceType[this.invoiceType[key]] = Number(key)
        }
      }
      for (const key in this.originFirstSubjects) {
        if (Object.hasOwnProperty.call(this.originFirstSubjects, key)) {
          swapKeyValueFirstSubjects[this.originFirstSubjects[key]] = Number(key)
        }
      }
      for (const key in this.originSecondSubjects) {
        if (Object.hasOwnProperty.call(this.originSecondSubjects, key)) {
          swapKeyValueSecondSubjects[this.originSecondSubjects[key]] = Number(key)
        }
      }
      for (const index in this.departments) {
        const department = this.departments[index]
        swapKeyValueDepartments[department.name] = Number(department.id)
      }
      const projectRequest = val.map(item => {
        return request('getAllProjectTable', {number: item.project_number})
      })
      const projects = await request.all.common(projectRequest).then(res => {
        return res.map(item => {
          return item.data.data[0]
        })
      })
      val.forEach((item, index) => {
        item.invoice_type = swapKeyValueInvoiceType[item.invoice_type]
        if (item.invoice_type === 1) { // 普通票
          item.tax_rate = 0
        }
        item.first_subject = swapKeyValueFirstSubjects[item.first_subject]
        if (!Object.keys(this.associatedRelationships[this.form.type]).includes(item.first_subject + '')) {
          item.first_subject = null
        }
        item.department_id = swapKeyValueDepartments[item.department_id]
        if ((item.project_number.length > 0 || item.project_number > 0) && projects[index]) {
          item.project_id = projects[index].id
          item.project_name = projects[index].name
          const projectNumberFirstChart = item.project_number[0]
          if (projectNumberFirstChart === 'H') { // 项目编号首字母为H
            item.canSelectDepartment = true
          } else { // 禁用 费用承担部门
            item.department_id = null
            item.canSelectDepartment = false
          }
        } else {
          item.canSelectDepartment = true
        }
        if (!item.first_subject) { // 没有 一级  设置 二级为空
          item.second_subject = null
        } else {
          const secondSubjects = {}
          const secondSubjectIds = this.associatedRelationships[this.form.type][item.first_subject]
          for (const index in secondSubjectIds) {
            const id = secondSubjectIds[index]
            secondSubjects[id] = this.originSecondSubjects[id]
          }
          this.secondSubjects[index + this.form.payment_detail.length] = secondSubjects
          let canFindSecondSubject = false
          for (const key in secondSubjects) {
            if (Object.hasOwnProperty.call(secondSubjects, key)) {
              const element = secondSubjects[key]
              if (element === item.second_subject) {
                item.second_subject = Number(key)
                canFindSecondSubject = true
                break
              }
            }
          }
          if (!canFindSecondSubject) {
            item.second_subject = null
          }
        }
      })
    },
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList, formField) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        formField.splice(index, 1)
      }
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    async onChangeFile (file, fileList, formField) {
      // 零工提现+银行卡时，检查是否已有文件（fileList.length > 1 表示尝试上传多个文件）
      if (this.isGigWorkerWithdrawBankCard && (formField.length > 0 || fileList.length > 1)) {
        this.$message.error('零工提现+银行卡时只能上传一个文件')
        this.$refs.upload.uploadFiles.pop()
        return false
      }
      // 零工提现+银行卡时，检查文件类型是否为excel
      if (this.isGigWorkerWithdrawBankCard) {
        const type = file.name.split('.').pop().toLowerCase()
        if (!['xls', 'xlsx'].includes(type)) {
          this.$message.error('零工提现+银行卡时只能上传EXCEL文件')
          this.$refs.upload.uploadFiles.pop()
          return false
        }
      }
      let isLt5M = file.raw.size / 1024 / 1024 < 50
      if (!isLt5M) {
        this.$message.error('文件内容必须小于50MB!')
        this.$refs.upload.uploadFiles.pop()
        return false
      }
      const type = file.name.split('.').pop().toLowerCase()
      let invoiceNumber = ''
      if (['jpeg', 'jpg', 'png'].includes(type)) {
        invoiceNumber = await this.recognitionQRCode(file.raw)
      } else if (['pdf'].includes(type)) {
        const pdfUrl = await this.loadPDF(file.raw)
        invoiceNumber = await this.recognitionPDFQRCode(pdfUrl)
      }
      this.$store.commit('OPEN_LOADING')
      await this.onUploadFile(file.raw, fileList, formField, invoiceNumber)
      this.$store.commit('CLOSE_LOADING')
    },
    // 加载PDF文件
    loadPDF (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          resolve(e.target.result)
        }
        reader.readAsDataURL(file)
      })
    },

    async recognitionPDFQRCode (url) {
      let loadingTask = PDFJS.getDocument(url)
      const pdfInfo = await loadingTask.promise
      const canvas = document.createElement('canvas')
      const page = await pdfInfo.getPage(pdfInfo.numPages)
      const viewport = page.getViewport({ scale: 2 })
      const context = canvas.getContext('2d')
      canvas.width = viewport.width
      canvas.height = viewport.height

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      }

      const renderTask = page.render(renderContext)
      return renderTask.promise.then(async () => {
        const imgUrl = canvas.toDataURL('image/jpeg')
        const invoiceNumber = await this.base64ToQRCode(imgUrl)
        return invoiceNumber
      })
    },

    recognitionQRCode (file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.readAsDataURL(file)
        fileReader.onload = async (e) => {
          resolve(await this.base64ToQRCode(e.target.result))
        }
      })
    },

    base64ToQRCode (data) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const image = new Image()
        image.src = data
        image.onload = () => {
          canvas.width = image.width
          canvas.height = image.height
          ctx.drawImage(image, 0, 0, image.width, image.height)
          const imageData = ctx.getImageData(0, 0, image.width, image.height)
          const result = jsQR(imageData.data, imageData.width, imageData.height)
          let invoiceNumber = ''
          if (result && result.data) {
            const data = result.data.split(',')
            if (data.length > 1) {
              const type = data[1]
              if (['01', '04'].includes(type)) {
                invoiceNumber = ''
              } else if (['08', '10', '31', '32'].includes(type)) {
                if (data.length > 3) {
                  invoiceNumber = data[3]
                } else {
                  invoiceNumber = ''
                }
              }
            } else {
              invoiceNumber = ''
            }
          }
          resolve(invoiceNumber)
        }
      })
    },

    onUploadFile (file, fileList, formField, invoiceNumber = '') {
      let formData = new FormData()
      formData.append('file', file)
      formData.append('invoice_number', invoiceNumber)
      this.id && formData.append('apply_id', this.id)
      return request.alert('finCenterUploadPaymentApplyFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type = file.name.split('.').pop().toLowerCase()
        if (['jpeg', 'jpg', 'png'].includes(type)) {
          type = 'pic'
        } else if (['pdf'].includes(type)) {
          type = 'pdf'
        } else if (['eml', 'html', 'htm'].includes(type)) {
          type = 'eml'
        } else if (['xlsx', 'doc', 'docx'].includes(type)) {
          type = 'office'
        } else if (['zip'].includes(type)) {
          type = 'zip'
        }
        if (index > -1) {
          formField[index] = {name: file.name, url: data, type: type, invoice_number: invoiceNumber}
        }
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
      })
    },
    trimSpace () {
      if (this.form.bank_account) {
        this.form.bank_account = this.form.bank_account.replace(/\s+/g, '')
      }
      this.form.desc = this.form.desc.replace(/\s+/g, '')
    },
    customerLabel (item) {
      if (item.remark) {
        return `${item.company_name}(${item.remark})/${item.id}`
      }
      return `${item.company_name}/${item.id}`
    },
    searchDepartments (name) {
      return request.common('getFinCenterDepartmentTableList', {...name, is_disabled: 0})
    },
    getDepartmentDetail (id, index) {
      return request.common('getFinCenterDepartmentDetail', id).then(res => {
        // 部门被禁用了
        if (res.data.is_disabled) {
          this.$set(this.form.payment_detail[index], 'department_id', null)
          return {data: {}}
        }
        return res
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.col-center {
  text-align:center
}
.invoice-row {
  .el-col {
    i {
      margin-top: 10px;
      font-size: 20px !important;
    }
  }
  // min-height: 80px;
}
.invoice-row .el-col {
  line-height: 40px;
  text-align: center;

}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/payment-manager-new/pages/PaymentManagerForm.vue